export const inputLight = {
  outline: 'none',
  border: 'none',
  padding: 'xxs',
  color: 'primary/text',
  borderRadius: 'xl',
  height: 44,
  backgroundColor: 'grey/light/background',
  labelColor: 'primary/text',
  fontSize: '16px',
  fontFamily: 'regular',
  letterSpacing: '0.5px',
  states: {
    '&::placeholder': {
      color: 'grey/light',
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
  inputTextStyleError: {
    bg: 'error/opacity',
    border: 'solid 1px',
    borderColor: 'error/bright',
    color: 'primary/text',
  },
};
